import axios from 'axios';

const endpoint = '/monitor-views';
const entity = 'monitor-view';
const key = 'name';
const parseParams = params => ((params.includes('?')) ? params.replace('?', '&') : params);

const state = {
  data: { data: [] },
};

const mutations = {
  data(state, value) {
    state.data = value;
  },
};

const actions = {
  get({ commit }, params = '') {
    return new Promise((resolve, reject) => {
      axios.get(`${endpoint}?$limit=200&$sort[updatedAt]=-1${params ? `&${parseParams(params)}` : ''}`)
        .then(({ data }) => {
          commit('data', data);
          resolve(data);
        })
        .catch(error => reject(error));
    });
  },
  find({}, id) {
    return new Promise((resolve, reject) => {
      if (!id) return reject();
      axios.get(`${endpoint}/${id}`)
        .then(({ data }) => resolve(data))
        .catch(error => reject(error));
    });
  },
  post({ dispatch }, body = {}) {
    return new Promise((resolve, reject) => {
      axios.post(`${endpoint}`, body)
        .then(({ data }) => {
          dispatch('get')
            .then(() => resolve({ creating: true, entity, key, data }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
  patch({ dispatch }, { id, body = {} }) {
    return new Promise((resolve, reject) => {
      if (!id) return reject();
      axios.patch(`${endpoint}/${id}`, body)
        .then(({ data }) => {
          dispatch('get')
            .then(() => resolve({ creating: false, entity, key, data }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
  delete({ dispatch }, id = '') {
    return new Promise((resolve, reject) => {
      if (!id) return reject();
      axios.delete(`${endpoint}/${id}`)
        .then(({ data }) => {
          dispatch('get')
            .then(() => resolve({ entity, key, data }))
            .catch(error => reject(error));
        })
        .catch(error => reject(error));
    });
  },
};

const getters = {
  data: state => state.data,
  list: state => (state.data && Array.isArray(state.data.data) ? state.data.data : []),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
